import { Alerts as AlertPopup, Button } from "@aph/ui-lib-humanx";
import React from "react";
import styles from "./alerts.module.scss";

interface Alertprops {
  isAlertOpen: boolean;
  alertMessage: string;
  setAlertMessage: (alertMessage: string) => void;
  setIsAlertOpen: (isAlertOpen: boolean) => void;
  changePincodeHandler?: () => void;
}

const Alerts: React.FC<Alertprops> = (props) => {
  const { isAlertOpen, alertMessage, setAlertMessage, setIsAlertOpen, changePincodeHandler } = props;
  if (!isAlertOpen) return null;

  return (
    <AlertPopup open={isAlertOpen} message={alertMessage} placement={""} modalAlert severity="error" title={"Warning"}>
      <Button
        color="primarybaby"
        onClick={() => {
          setIsAlertOpen(false);
          setAlertMessage("");
          changePincodeHandler && changePincodeHandler();
        }}
        title={"Close"}
        className={styles.alertButton}
      >
        Done
      </Button>
    </AlertPopup>
  );
};

export default Alerts;
